import "./App.css";
import React from "react";
import AuroraBackground from "./components/AuroraBackground/AuroraBackground";
import Footer from "./components/Footer/Footer";
import Hero from "./components/Hero/Hero";
import Loader from "./components/Loader/Loader";

function App() {
  const [theme, setTheme] = React.useState("dark");
  const [screenLoading, setScreenLoading] = React.useState(false);

  React.useEffect(() => {
    setScreenLoading(true);
    setTimeout(() => {
      setScreenLoading(false);
    }, 3000);
  }, []);

  React.useEffect(() => {
    theme && document.documentElement.setAttribute("data-theme", theme);
  }, [theme]);

  return (
    <>
      {screenLoading ? (
        <Loader />
      ) : (
        <div className="fade-in h-screen">
          <AuroraBackground theme={theme} />

          <Hero theme={theme} setTheme={setTheme} />

          <Footer />
        </div>
      )}
    </>
  );
}

export default App;
